import { P2GBox, P2GCard, P2GContainer, P2GGrid, P2GLink, P2GText } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { CmsContent, useTenant } from '@parcel2go/npm-p2g-app';
import { useNavigate } from 'react-router-dom';
import { NoTrackingSearchAdditionalContent } from '~/components/tracking/no-tracking-additional-content';
import TrackingSearchBox from '~/components/tracking/search';
import { Suspense } from 'react';
import { TranslationNamespaces } from '~/lib/constants';
import { PublicSettings } from '~/lib/ui-serverless-settings';

export function Component() {
  const navigate = useNavigate();
  const profile = useTenant();
  const { t } = useTranslation(TranslationNamespaces.TRACKING);

  function onSearchClick(value: string) {
    navigate(`./${encodeURIComponent(value)}`);
  }

  const { settings } = useTenant();

  const websiteUrl = settings[PublicSettings.WEBSITE];
  const supportUrl = `${websiteUrl}/help-centre`;

  // Two Column
  if (profile?.settings?.showTrackingIntro === 'true') {
    return (
      <>
        <P2GBox classNames={'p2g-search-hero'}>
          <P2GContainer>
            <P2GBox pt={4} pb={4}>
              <P2GGrid container spacing={2}>
                <P2GGrid item md={6}>
                  <P2GText variant="h2">
                    <Trans t={t} i18nKey="SEARCH_TITLE" defaults="Parcel tracking" />
                  </P2GText>
                  <CmsContent contentKey={'TRACKING.SEARCH.INTRO'} />
                </P2GGrid>
                <P2GGrid item md={6}>
                  <P2GCard>
                    <P2GGrid container direction="column" spacing={2}>
                      <P2GGrid item>
                        <Trans
                          t={t}
                          i18nKey="SEARCH_DESCRIPTION"
                          defaults="To track your parcel please enter your parcel reference number in the field below then click 'Track this parcel'. You will receive a live update regarding our shipments and deliveries."
                        />
                      </P2GGrid>
                      <P2GGrid item>
                        <TrackingSearchBox onClick={onSearchClick} />
                      </P2GGrid>
                      <P2GGrid item>
                        <Trans
                          t={t}
                          i18nKey="SEARCH_HELP"
                          defaults="If you need any further assistance with your parcel tracking please contact our <0>Help Centre</0>"
                          components={[<P2GLink href={`${websiteUrl}/help-centre`} />]}
                        />
                      </P2GGrid>
                    </P2GGrid>
                  </P2GCard>
                </P2GGrid>
              </P2GGrid>
            </P2GBox>
          </P2GContainer>
        </P2GBox>
        <P2GBox pt={4} pb={4}>
          <P2GContainer>
            <P2GGrid container direction="column" spacing={2}>
              <CmsContent contentKey="TRACKING.SEARCH.CONTENT" />
              <CmsContent contentKey="TRACKING.SEARCH.FAQ" />
            </P2GGrid>
          </P2GContainer>
        </P2GBox>
        <CmsContent contentKey={'LAYOUT.PREFOOTER'} />
      </>
    );
  }

  return (
    <>
      <P2GContainer>
        <P2GBox pt={4} pb={4}>
          <P2GGrid container direction="column" spacing={2}>
            <P2GGrid item>
              <P2GCard>
                <P2GBox p={4}>
                  <P2GGrid container direction="column" spacing={2}>
                    <P2GGrid item>
                      <Trans
                        t={t}
                        i18nKey="SEARCH_DESCRIPTION"
                        defaults="To track your parcel please enter your parcel reference number in the field below then click 'Track this parcel'. You will receive a live update regarding our shipments and deliveries."
                      />
                    </P2GGrid>
                    <P2GGrid item>
                      <TrackingSearchBox onClick={onSearchClick} />
                    </P2GGrid>
                    <NoTrackingSearchAdditionalContent />
                    <P2GGrid item>
                      <Trans
                        t={t}
                        i18nKey="SEARCH_HELP"
                        defaults="If you need any further assistance with your parcel tracking please contact our <0>Help Centre</0>"
                        components={[<P2GLink href={supportUrl} />]}
                      />
                    </P2GGrid>
                  </P2GGrid>
                </P2GBox>
              </P2GCard>
            </P2GGrid>
            <CmsContent contentKey="TRACKING.SEARCH.CONTENT" />
            <CmsContent contentKey="TRACKING.SEARCH.FAQ" />
          </P2GGrid>
        </P2GBox>
      </P2GContainer>
      <Suspense>
        <CmsContent contentKey={'LAYOUT.PREFOOTER'} />
      </Suspense>
    </>
  );
}

Component.displayName = 'Tracking';
